export const DZComponentsNames = {
  subtitle: 'subtitle',
  search: 'search',
  listInTwoColumns: 'list-in-2-columns',
  quote: 'quote',
  image: 'image',
  editor: 'editor',
  community: 'community',
  faq: 'faq',
  faqBlock: 'faq-block',
  communitiesList: 'communities-list',
  agentsList: 'agents-list',
  link: 'link',
  listWithIcons: 'list-with-icons',
  advisors: 'advisors',
  linksBlock: 'links-block',
  video: 'video',
  youTubeVideoLink: 'you-tube-video-link',
  infoBlock: 'info-block',
  listWithImg: 'list-with-img',
  threeColumnValue: 'three-column-value',
  typeform: 'typeform',
  itemWithIcon: 'item-with-icon',
  iframeContent: 'iframe-content',
  carePlans: 'care-plan'
};
